import { SET_COMPONENT_FIELD } from './actions';

const initialState = {
    isSelected: false,
    name: '',
    code: '',
    desc: '',
};

export function componentReducer(state = initialState, action) {
    switch (action.type) {
        case SET_COMPONENT_FIELD:
            return { ...state, [action.key]: action.value };
        default:
            return state;
    }
}
